import { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { categories, articles, faqs } from '@/mocks/data';

const articleImages: Record<string, string> = {
  '1': 'https://knowguide.github.io/api/search-image?query=Soft%20warm%20abstract%20illustration%20of%20anatomical%20education%20with%20gentle%20coral%20and%20peach%20tones%2C%20simple%20clean%20medical%20education%20style%2C%20minimal%20composition%20with%20organic%20flowing%20shapes%20representing%20body%20positivity%2C%20warm%20neutral%20background&width=800&height=500&seq=article-thumb-1&orientation=landscape',
  '2': 'https://knowguide.github.io/api/search-image?query=Artistic%20abstract%20representation%20of%20human%20body%20and%20wellness%20with%20soft%20peachy%20warm%20tones%2C%20flowing%20organic%20lines%20suggesting%20natural%20bodily%20rhythms%2C%20calm%20educational%20medical%20illustration%20style%2C%20gentle%20minimalist%20composition%20with%20warm%20neutral%20background&width=800&height=500&seq=article-thumb-2&orientation=landscape',
  '3': 'https://knowguide.github.io/api/search-image?query=Warm%20minimalist%20illustration%20of%20two%20people%20having%20a%20gentle%20caring%20conversation%2C%20soft%20coral%20and%20peach%20tones%2C%20emotional%20wellness%20theme%2C%20abstract%20flowing%20shapes%20suggesting%20connection%20and%20understanding%2C%20calm%20safe%20atmosphere%2C%20contemporary%20illustration%20style&width=800&height=500&seq=article-thumb-3&orientation=landscape',
  '4': 'https://knowguide.github.io/api/search-image?query=Minimalist%20abstract%20illustration%20representing%20communication%20and%20mutual%20understanding%2C%20two%20overlapping%20gentle%20circles%20in%20warm%20coral%20and%20peach%2C%20soft%20watercolor%20texture%2C%20calm%20and%20trusting%20atmosphere%2C%20contemporary%20art%20style%20with%20clean%20composition&width=800&height=500&seq=article-thumb-4&orientation=landscape',
  '5': 'https://knowguide.github.io/api/search-image?query=Clean%20minimalist%20medical%20illustration%20showing%20various%20contraceptive%20options%20in%20abstract%20geometric%20style%2C%20warm%20beige%20and%20sage%20green%20tones%2C%20educational%20yet%20approachable%20design%2C%20soft%20rounded%20shapes%2C%20calm%20professional%20medical%20aesthetic&width=800&height=500&seq=article-thumb-5&orientation=landscape',
  '6': 'https://knowguide.github.io/api/search-image?query=Abstract%20medical%20infographic%20style%20illustration%20about%20health%20protection%2C%20soft%20sage%20green%20and%20warm%20beige%20tones%2C%20shield-like%20geometric%20shapes%20suggesting%20protection%2C%20clean%20educational%20aesthetic%20with%20minimal%20composition%2C%20calm%20reassuring%20atmosphere&width=800&height=500&seq=article-thumb-6&orientation=landscape',
  '7': 'https://knowguide.github.io/api/search-image?query=Abstract%20illustration%20breaking%20stereotypes%20with%20warm%20coral%20tones%2C%20fragmented%20geometric%20shapes%20dissolving%20into%20soft%20organic%20forms%2C%20symbolizing%20myth-breaking%20and%20truth%2C%20contemporary%20minimalist%20art%20style%2C%20soft%20peachy%20background&width=800&height=500&seq=article-thumb-7&orientation=landscape',
  '8': 'https://knowguide.github.io/api/search-image?query=Conceptual%20minimalist%20illustration%20of%20myths%20being%20dispelled%2C%20lightbulb%20moment%20theme%20with%20warm%20amber%20glow%2C%20abstract%20geometric%20shapes%20transitioning%20from%20confusion%20to%20clarity%2C%20soft%20peach%20and%20warm%20beige%20tones%2C%20educational%20yet%20artistic%20style&width=800&height=500&seq=article-thumb-8&orientation=landscape',
};

function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://knowguide.github.io/api/search-image?query=Warm%20abstract%20minimalist%20illustration%20with%20soft%20coral%20peach%20and%20beige%20gradients%2C%20organic%20flowing%20shapes%20suggesting%20growth%20and%20education%2C%20gentle%20ethereal%20atmosphere%2C%20contemporary%20art%20style%20with%20diffused%20light%2C%20calm%20and%20safe%20ambiance%2C%20no%20text%20no%20people%2C%20abstract%20composition&width=1600&height=800&seq=hero-main-2026&orientation=landscape"
          alt="青春性教育"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 font-heading leading-tight">
          以科学之光
          <br />
          照亮青春的每一步
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          从科学、心理、健康角度全面解析初次性行为的相关知识，
          帮助每一位青少年以正确认知面对人生重要时刻。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/kexue-zhishi"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-sm"
          >
            开始了解
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/changjian-wuqu"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-white border border-white/30 font-medium rounded-full hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap text-sm"
          >
            破解常见误区
          </Link>
        </div>
      </div>
    </section>
  );
}

function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
            探索知识领域
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            从四个维度系统了解初次性行为的方方面面
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => {
            const colorMap: Record<string, { bg: string; text: string; border: string }> = {
              primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-200/70' },
              accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-200/70' },
              secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', border: 'border-secondary-200/70' },
            };
            const c = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group p-6 rounded-2xl bg-background-50 border ${c.border} hover:shadow-sm transition-all duration-300`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${c.bg} ${c.text} mb-5 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2 font-heading">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
                  <span>浏览文章</span>
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm">
              来自专业医生和心理咨询师的科学解读
            </p>
          </div>
          <Link
            to="/category/kexue-zhishi"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:shadow-sm transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3 text-xs text-foreground-500">
                  <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-medium">
                    {categories.find((c) => c.slug === article.category)?.name}
                  </span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200/70 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">
                    {article.author} · {article.publishDate}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
            常见问题解答
          </h2>
          <p className="text-foreground-600">
            你可能关心的问题，这里有科学、诚实的答案
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-${openIndex === idx ? 'subtract' : 'add'}-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('phone_alt') as string || '').trim();
    if (honeypotVal) {
      setSubmitted(true);
      return;
    }

    try {
      const res = await fetch('https://knowguide.github.io/api/form/d9u4e9v8l97n3eas3h3g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore parse error */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(serverMsg || '提交失败，请稍后再试');
        }
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-primary-500">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">
          获取最新科普资讯
        </h2>
        <p className="text-primary-100 mb-8">
          订阅我们的资讯，获取科学、温暖的性教育知识，陪伴你健康成长。
        </p>
        {submitted ? (
          <div className="bg-background-50/15 backdrop-blur-sm rounded-xl px-6 py-8">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-background-50/20 mb-4">
              <i className="ri-check-line text-2xl text-background-50"></i>
            </div>
            <p className="text-background-50 font-semibold text-lg">订阅成功！</p>
            <p className="text-primary-100 text-sm mt-2">感谢你的关注，我们会定期发送精选内容到你的邮箱。</p>
          </div>
        ) : (
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <div className="honeypot-field">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入你的邮箱地址"
              className="flex-1 w-full px-5 py-3.5 rounded-full bg-background-50 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none border-2 border-transparent focus:border-accent-400 transition-colors"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-medium hover:bg-accent-600 transition-all duration-300 whitespace-nowrap text-sm"
            >
              立即订阅
            </button>
          </form>
        )}
        {formError && (
          <p className="text-primary-100 text-sm mt-3">{formError}</p>
        )}
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <CategorySection />
      <FeaturedArticles />
      <FaqSection />
      <NewsletterSection />
    </Layout>
  );
}